module.exports = __webpack_public_path__ + "static/card-punch-e4deb76038e603a34254985be1af35a8.png";